import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Select } from 'antd';
import useHousingStockHouses from '../../../../../queries/useHousingStockHouses';
import { selectors, actions } from '../../../model';
import { uploadingFieldNames } from '../../../config/uploadingStep';
import { baseQueryOptions } from '../../../config/queries';
import { createHouseName } from '../../../lib/addresses';
import { getReplacedString } from '../../../../../../../helpers/getReplacedString';
import FormItem from '../../ui/FormItem/FormItem';

const { selectUploadingStepValue, selectUploadingStepError, selectCompanyId } =
  selectors;
const { houseChangeAction } = actions;

const houseName = uploadingFieldNames.house;

const valueSelector = (state) => selectUploadingStepValue(state, houseName);
const errorSelector = (state) => selectUploadingStepError(state, houseName);

const select = (data) =>
  Array.isArray(data)
    ? data.map((house) => ({ id: house.houseId, name: createHouseName(house) }))
    : data;

const FieldWrapper = ({ children }) => {
  const errors = useSelector(errorSelector);

  return (
    <FormItem
      required
      label="Дом"
      errors={errors}
    >
      {children}
    </FormItem>
  );
};

const filterOption = (input, option) => {
  const target = getReplacedString(option.props.children);
  const search = getReplacedString(input);
  return target.includes(search);
};

const HouseSelect = () => {
  const companyId = useSelector(selectCompanyId);
  const value = useSelector(valueSelector);

  const dispatch = useDispatch();

  const { data: houses, isFetching } = useHousingStockHouses(
    { companyId },
    {
      ...baseQueryOptions,
      enabled: Boolean(companyId),
      staleTime: Infinity,
      select,
    }
  );

  const handleChange = (value) => dispatch(houseChangeAction(value));

  return (
    <FieldWrapper>
      <Select
        showSearch={houses?.length > 8}
        filterOption={filterOption}
        loading={Boolean(isFetching)}
        disabled={!companyId}
        labelInValue
        value={Boolean(houses?.length) ? value : undefined}
        style={{ width: '100%' }}
        onChange={handleChange}
        placeholder="Выберите дом"
      >
        {houses?.map(({ id, name }) => (
          <Select.Option
            value={id}
            key={id}
          >
            {name}
          </Select.Option>
        ))}
      </Select>
    </FieldWrapper>
  );
};

export default HouseSelect;
